<template>
  <div>
    <PendingPrs/>
  </div>
</template>
  
  <script>
  // @ is an alias to /src
  import PendingPrs from '@/components/EmployeePendingPrs.vue'
  
  export default {
    name: 'penidng-approval-view',
    components: {
      PendingPrs
    }
  }
  </script>
  